<template>
  <!--  <card-->
  <!--      v-if="conclusion && conclusion.food_recommendation"-->
  <!--      :loading="loading"-->
  <!--      :maxWidth="'auto'"-->
  <!--      :width="'100%'"-->
  <!--      style="margin: 24px 0 0 0;"-->
  <!--  >-->

  <collapse-card v-if="conclusion && conclusion.food_recommendation" :loading="loading" open>


    <div slot="title">Питание</div>
    <div slot="link">
      <div class="edit-link">Сохранить</div>
    </div>

    <!--    <subtitle-divider>Особенности в питании</subtitle-divider>-->

    <el-row type="flex" align="middle">
      <el-col :span="24">
        <div class="block-title">Порции</div>

        <div class="portions">
          <div class="portions__mini">
            <el-input
                v-model="conclusion.food_recommendation.number_meals"
                maxlength="15"
                class="number-widget__input"/>
          </div>

          <div class="portions__max">
            <el-input
                v-model="conclusion.food_recommendation.number_meals_description"
                maxlength="50"
                class="number-widget__input "/>
          </div>
        </div>

      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start">
      <el-col :span="24" class="number-widget-content">
        <div class="number-widget">
          <div class="number-widget__number">
            <el-input
                v-model="conclusion.food_recommendation.proteins"
                class="number-widget__input append">
              <div slot="suffix">Белки,г</div>
            </el-input>
          </div>
        </div>

        <div class="number-widget">
          <div class="number-widget__number">
            <el-input
                v-model="conclusion.food_recommendation.fats"
                class="number-widget__input append">
              <div slot="suffix">Жиры,г</div>
            </el-input>
          </div>
        </div>
        <div class="number-widget">
          <div class="number-widget__number">
            <el-input
                v-model="conclusion.food_recommendation.carbohydrates"
                class="number-widget__input append">
              <div slot="suffix">Углеводы,г</div>
            </el-input>
          </div>
        </div>
        <!--        <div @click="setEditableFeaturesFood" class="edit-icon">-->
        <!--          <save-icon v-if="sectionEditableFeaturesFood" @click="update"/>-->
        <!--          <i v-else class="edit-icon el-icon-edit"></i>-->
        <!--        </div>-->

      </el-col>

    </el-row>

    <div class="recommended">
      <div class="block-title">Способ приготовления</div>
      <div class="recommended__edit">
        <div class="recommended__edit_text">
          <el-input
              v-model="conclusion.food_recommendation.cooking_method"
              class="number-widget"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5}"
          />
        </div>

        <!--        <span @click="setEditableCookingMethod" class="edit-icon">-->
        <!--          <save-icon v-if="sectionEditableCookingMethod" @click="update"/>-->
        <!--          <i v-else class=" el-icon-edit"></i>-->
        <!--        </span>-->

      </div>
    </div>
    <div class="block-title">Необходимые элементы</div>

    <div class="food-elements">
      <div
          v-for="food of food.elements" :key="food.id"
          class="food-elements__item required-item">
        <div class="required-item__title required-item-title">
          <el-image class="required-item-title__icon"
                    :fit="'cover'"
                    src="https://image.flaticon.com/icons/png/512/1048/1048641.png"/>
          <div class="required-item-title__title">{{ food.title }}</div>
        </div>
        <div class="required-item__input">
          <el-input
              v-model="conclusion.food_recommendation[food.value]"
              class="number-widget"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8}"
              size="small"
          />

        </div>

      </div>
    </div>

    <div class="block-title">Продукты</div>

    <product-recommendation :data-table="conclusion.food_product_recommendation" @update="update"/>

  </collapse-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import ProductRecommendation from "@/components/visit/conclusion/ProductRecommendation.vue"
import CollapseCard from "@/components/elements/BigCard.vue"

export default {
  name: "Food",
  components: {CollapseCard, ProductRecommendation},
  data() {
    return {
      sectionEditableFeaturesFood: false,
      sectionEditableCookingMethod: false,
      loading: false,
      // Харкодр - т.к поля жестко зафиксированы на сервере
      food: {
        elements: [
          {
            id: 1,
            title: 'Витамины',
            value: 'vitamins',
            editable: false
          },
          {
            id: 2,
            title: 'Минералы',
            value: 'minerals',
            editable: false
          },
          {
            id: 3,
            title: 'Незаменимые ЖК',
            value: 'fatty_acid',
            editable: false
          }],
      }
    }
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion"
        }
    ),
    visitId() {
      return this.$route.params.id;
    },
  },
  watch: {},
  filters: {
    getDeclination(value) {
      if (!value) return ""

      const arr = value.split("-")
      let lastNumber = arr[arr.length - 1]

      lastNumber %= 100
      if (lastNumber >= 5 && lastNumber <= 20) return "порций"
      lastNumber %= 10
      if (lastNumber === 1) return "порция"
      if (lastNumber >= 2 && lastNumber <= 4) return "порции"
      return "порций"
    }
  },
  methods: {
    ...mapActions({
      updateConclusion: "visit/UPDATE_CONCLUSION",
    }),
    setEditableFeaturesFood() {
      this.sectionEditableFeaturesFood = !this.sectionEditableFeaturesFood
      this.$forceUpdate()
    },
    setEditableCookingMethod() {
      this.sectionEditableCookingMethod = !this.sectionEditableCookingMethod

    },
    next() {
      console.log('next')
      this.loading = true
    },
    update() {

      this.loading = true
      this.updateConclusion(this.conclusion).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка 😕",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loading = false
      })

    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";

.subtitle {
  margin-top: 12px;

  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  color: #111;

}

.block-title {
  margin-top: 24px;

  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #111;
}


.recommended {
  margin-top: 30px;
  //display: flex;
  //justify-content: space-between;
  //align-items: center;


  &__edit {


    &_text {
      width: 100%;
      margin-top: 6px;

      font-size: 15px;
      line-height: 20px;

      color: #8E8E93;

    }


  }
}

.edit-icon {
  color: #8E8E93;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    opacity: 0.5
  }
}

.portions {
  width: 100%;

  display: flex;

  font-weight: 600;
  font-size: 32px;
  line-height: 41px;
  color: #111;

  &__mini {
    width: 100px;

    /deep/ .el-input__inner {
      border-radius: 4px 0 0 4px;
      border-right: 0 !important;
    }
  }

  &__max {
    flex: 1;

    /deep/ .el-input__inner {
      border-radius: 0 4px 4px 0;
    }
  }

}

.number-widget-content {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}


.required-item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #F6F8F9;

  margin-bottom: 12px;

  &__input {
    width: 60%;

    font-size: 14px;
    line-height: 24px;
    color: #111111;

    background: #fff;

    /deep/ .el-textarea__inner {
      border-radius: 0 4px 4px 0;
    }
  }
}

.required-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 7px 0 7px 12px;

  &__icon {
    width: 26px;
    background: #FFC65B;
    border-radius: 6px;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #111;
  }
}

.number-widget {

  &__number {
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;

    color: #111;
  }

  &__title {
    font-size: 13px;
    line-height: 16px;
    color: #111;
  }

  &__input {

    /deep/ input {
      //max-width: 98px;

    }

    &_max {
      /deep/ input {
        max-width: 100%;
      }
    }

  }

}

.append /deep/ {
  .el-input__suffix {
    top: 6px;
  }

  .el-input__suffix-inner div {
    padding-right: 8px;
  }
}


.food-elements {
  margin-top: 16px;

  &__icon {
    width: 26px;
  }

  &__title {
    padding: 19px 0;

    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #111;
  }

  &__value {
    white-space: pre-wrap;

    font-size: 11px;
    line-height: 13px;
    color: #111;
  }

  &__edit-icon {
    font-size: 13px;
    color: #8E8E93;
    cursor: pointer;

    &:hover {
      opacity: 0.5
    }
  }

}

.edit-link {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  line-height: 26px;

  color: #43D3B3;

  &:hover {
    opacity: .5;
  }
}
</style>